// ============================================
// PREVIEWPRODUCTO.JS — Tooltip flotante de specs (escritorio, hover)
// ============================================
// Aparece al hacer hover sobre la tarjeta. Pointer-events none para
// no interferir con el mouse. Reposiciona si se sale del viewport.

import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import { extraerFeatures } from '../utils/extractorFeatures';
import { PP } from './helpersClientes';

export default function PreviewProductoTooltip({ producto, anchorRef, visible }) {
  const tooltipRef = useRef(null);
  const [posicion, setPosicion] = useState({ top: -9999, left: -9999 });

  useEffect(() => {
    if (!visible || !anchorRef?.current || !tooltipRef.current) return;
    const calcular = () => {
      const anchor = anchorRef.current.getBoundingClientRect();
      const tooltip = tooltipRef.current.getBoundingClientRect();
      const vw = window.innerWidth;
      const vh = window.innerHeight;

      let left = anchor.right + 12;
      if (left + tooltip.width > vw - 20) {
        left = anchor.left - tooltip.width - 12;
      }
      if (left < 12) left = 12;

      let top = anchor.top;
      if (top + tooltip.height > vh - 20) {
        top = vh - tooltip.height - 20;
      }
      if (top < 20) top = 20;

      setPosicion({ top, left });
    };
    calcular();
    window.addEventListener('scroll', calcular, true);
    window.addEventListener('resize', calcular);
    return () => {
      window.removeEventListener('scroll', calcular, true);
      window.removeEventListener('resize', calcular);
    };
  }, [visible, anchorRef, producto]);

  if (!visible || !producto) return null;

  const features = extraerFeatures(producto);
  const nombreCompleto = producto.titulo || producto.nombre || 'Producto';
  const sku = producto.modelo || producto.sku || producto.clave || producto.id_unico || '';
  const marca = producto.marca || '';

  const contenido = (
    <div
      ref={tooltipRef}
      data-preview-tooltip="true"
      style={{
        position: 'fixed',
        top: posicion.top,
        left: posicion.left,
        background: '#1e293b',
        color: '#fff',
        padding: 16,
        borderRadius: 12,
        boxShadow: '0 12px 32px rgba(0,0,0,0.3)',
        maxWidth: 360,
        width: 320,
        zIndex: 999999,
        fontSize: 13,
        lineHeight: 1.5,
        pointerEvents: 'none',
        fontFamily: PP,
      }}
    >
      <div style={{ fontWeight: 700, fontSize: 14, marginBottom: 6, lineHeight: 1.3 }}>
        {nombreCompleto}
      </div>
      {(sku || marca) && (
        <div style={{ display: 'flex', gap: 8, marginBottom: 12, flexWrap: 'wrap' }}>
          {marca && (
            <span style={{ color: '#94b803', fontSize: 11, fontWeight: 700, textTransform: 'uppercase' }}>
              {marca}
            </span>
          )}
          {sku && (
            <span style={{ color: '#5c9adb', fontSize: 12 }}>{sku}</span>
          )}
        </div>
      )}

      {features.length > 0 ? (
        <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
          {features.map((f, i) => (
            <li key={i} style={{
              display: 'flex', gap: 8, marginBottom: 6, alignItems: 'flex-start',
            }}>
              <span style={{ color: '#5c9adb', fontWeight: 700, flexShrink: 0 }}>›</span>
              <span style={{ flex: 1 }}>
                {f.etiqueta && (
                  <strong style={{ color: '#94b803' }}>{f.etiqueta}: </strong>
                )}
                {f.valor || ''}
              </span>
            </li>
          ))}
        </ul>
      ) : (
        <div style={{ color: '#94a3b8', fontStyle: 'italic' }}>
          Sin caracteristicas extraidas. Click para ver ficha completa.
        </div>
      )}
    </div>
  );

  return ReactDOM.createPortal(contenido, document.body);
}
